import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { NgrxFormsModule } from 'ngrx-forms';
import { AccountSettingService } from './state/account-setting.service';
import { EffectsModule } from '@ngrx/effects';
import { AccountSettingEffects } from './state/account-setting.effects';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        UpgradeModule,
        FormsModule,
        NgrxFormsModule,
        ReactiveFormsModule,
        EffectsModule.forFeature([AccountSettingEffects]),
    ],
    declarations: [
    ],
    providers: [
        AccountSettingService
    ]
})
export class AccountSettingModule {
}
